import { Component, EventEmitter, Output } from '@angular/core';

const routes = [
  {
    label: 'Terms & Conditions',
    path: 'terms-conditions',
    targetId: 'terms-conditions',
  },
  {
    label: 'Privacy Policy',
    path: 'privacy-policy',
    targetId: 'privacy-policy',
  },
  {
    label: 'Partnership Terms',
    path: 'premium-terms',
    targetId: 'premium-terms',
  },
  {
    label: 'Careers',
    href: 'https://angel.co/ten-thousand-coffees/jobs',
    targetId: 'careers',
  },
  {
    label: 'Help Center',
    href: 'https://help.tenthousandcoffees.com',
    targetId: 'help',
  },
];

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
})
export class FooterComponent {
  @Output() trackAnalytics = new EventEmitter();
  routes = routes;

  trackInteractionAnalytics(properties) {
    this.trackAnalytics.emit(properties);
  }
}
